import React, { useEffect, useState } from "react";
import Pagination from '@/components/Pagination';
import Loader from '@/components/Loader';
import EditableTable from "./Table";
import Modal from "@/components/Modal"
import ChangeLog from "@/components/ChangeLog";
import api from "@/auth/api";
import { alertSuccess, alertError } from '@/components/Alert';
import Add from "./Add";

export default function UserBlackList({editable}) {
  const [data, setData] = useState([]);
  const [changeLogData,setChangeLogData] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const itemsPerPage = 10;
  const editableFields = ['title', 'status', 'blackListType', 'is_blackList'];
  const [addDis, setAddDis] = useState(false);
  const [blackListType, setBlackListType] = useState([]);
  const [detailText, setDetailText] = useState(null);
  const [detailDis, setDetailDis] = useState(false);

  useEffect(() => {
    fetchData();
    getBlackListTypeList();
  }, []);

    const getBlackListTypeList = async () => {
    try {
      const response = await api.get("/PanelHome/panel/blackListType");
      setBlackListType(response.data.result);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const response = await api.get("/PanelHome/panel/UserblackList");
      setData(response.data.result);
      setChangeLogData(response.data.Change_Log);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  
  const handleEdit = (rowId) => {
    setEditRowId(rowId);
   const rowData = data.find((item) => item.id === rowId);
    setEditedData(rowData);
    setDetailText(null);
  };

  const handleSave = async () => {
   setDetailDis(true);
  };


const handleSaveByDetailText = async ()=>{
  if(detailText.trim()=="") return 
 const blackListId = blackListType.filter(f=>f.title==editedData.blackListType)[0]?.id;  
    try {
      const finalData = {
        id:editedData.id,
        Type:blackListId,
        is_blackList:editedData.is_blackList,
        detail:detailText
      }

      await api.patch(`/PanelHome/panel/UserblackList`,finalData);
      alertSuccess("Data updated successfully");
      setEditRowId(null);
      fetchData();
      setDetailDis(false)
    } catch (error) {
      alertError(error?.response?.data?.errors)
      console.error("Error updating data:", error);
    }
  }

  const handleAdd = async () => {
    setAddDis(true)
  };

  const handleLog = (id) => {
    const logData = changeLogData.filter((f) => f.id === id)[0]
      ?.oldTrack;
    console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    setIsModalOpen(true)
  };


  
  const handleChange = (e, field, val) => {
    if (field === "is_active" || field === "editable" || field === "optional" || field === "status" || field === "is_blackList") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };


  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const headers = data.length > 0 ? Object.keys(data[0]).filter(key => key !== 'id') : [];




  if (loading) return <Loader />;

  return (

    <>
    <div className="flex flex-col items-center p-6 pt-2">
    {/* <h1 className="text-xl m-4 font-semibold">Black List Type</h1> */}
    <div className="w-full flex items-center flex-col">        
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        editableFields={editableFields}
        handleChange={handleChange}
        handleLog={handleLog}
        blackListTypeList={blackListType}
        fetchData={fetchData}
        editable={editable}
      />
      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />

        {/* {editable &&  <button className="activeBtn text-sm text-white py-1 px-2 rounded" onClick={handleAdd}>
          + Add User Black List
        </button>} */}
       
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Change Log" content={<ChangeLog data={currentLog} />} />


      <Modal isOpen={addDis} onClose={()=>setAddDis(false)} title="Add user black list" content={<Add onSuccess={fetchData} onClose={()=>setAddDis(false)}/>} />
      
    </div>
        </div>

        <Modal 
        isOpen={detailDis}
        onClose={()=>setDetailDis(false)}
        title="Detail Message"
        content={<div>
          <input type="text" value={detailText} onChange={(e)=>setDetailText(e.currentTarget.value)}/>
         <button type='submit' onClick={()=>handleSaveByDetailText()} className=' ml-2 activeBtn rounded-sm w-fit text-white p-2'>
        Submit
      </button>
        </div>}
        />
    </>
 
  );
}
